import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { RouterModule } from '@angular/router';
import { NOT_FOUND_ROUTES } from './not-found-page/not-found.routes';

@NgModule({
  imports: [CommonModule, SharedUtilsTranslationModule, RouterModule.forChild(NOT_FOUND_ROUTES)],
  declarations: [NotFoundPageComponent]
})
export class HffCommonUiNotFoundPageModule {}
